import { Component, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { XlsxData } from '../../providers/xlsx';
import { has, isEmpty } from 'lodash';
import { Utilities } from '../../providers/utilities';
import { LoadingController, ToastController } from 'ionic-angular';
import { XlsApiPipe } from '../../pipes/xls-api/xls-api';

@Component({
  selector: 'app-import-xlsx',
  templateUrl: 'import-xlsx.component.html'
})

export class ImportXlsxComponent {

  @ViewChild('fileInput') public fileInput: ElementRef;

  @Input('sheets') public sheets: string[];

  @Input('sheets_required') public sheets_required: string[];

  @Input('nameButton') public nameButton: string = 'Select file XLSX';

  @Input('endpoint') public endpoint: string;

  @Input('button_name') public button_name: string = 'Create Flash Event'

  @Output('emitRecords') public emitRecords: EventEmitter<any> = new EventEmitter<any>();

  @Output('emitFile') public emitFile: EventEmitter<any> = new EventEmitter<any>();

  public fileName: String;

  public resultData: any = null;

  public isProcess: boolean = false;

  private loadFiles: any = null;

  constructor(
    private xlsxData: XlsxData,
    private utilities: Utilities,
    private xlsPipe: XlsApiPipe,
    private toastCtrl: ToastController
  ) { }

  public openFileInput() {
    this.fileInput.nativeElement.click();
  }

  public fileChange(event) {
    const files: FileList = event.srcElement.files;
    if (files.length > 0) {
      this.fileName = files.item(0).name;
      this.loadFiles = files;
      this.sendFile(files);
    }
  }

  public sendFile(files) {
    let loading = this.utilities.setLoading();

    this.fileName = files.item(0).name;
    this.xlsxData.sendToXslxEndpoint(this.endpoint, files.item(0), this.sheets).subscribe(
      (res) => {
        this.utilities.consoleDecorator('Data API', res);
        if (res) {
          this.resultData = res;
        } else {
          this.resultData = null;
        }
        this.canEmitFileData();
        loading.dismiss();
      },
      (error) => {
        this.utilities.consoleError('error xlsx api', error);
        this.canEmitFileData();
        loading.dismiss();
      }
    );
  }

  public isRequired(sheet) {
    return this.sheets_required.indexOf(sheet) > -1
  }

  public hasErrorsBySheet(sheet) {
    if (has(this.resultData, sheet) && !isEmpty(this.resultData[sheet].errors)) {
      let sumErrors = 0;
      this.resultData[sheet].errors.forEach(element => {
        sumErrors += element.row.length;
      });

      return sumErrors;
    }

    return false;
  }

  private canEmitFileData() {
    let result = true;
    let message = '';

    if (this.resultData) {
      for (let sheet of this.sheets) {
        let sheet2 = this.xlsPipe.transform(sheet);
        if (this.resultData[sheet2]) {
          if (!isEmpty(this.resultData[sheet2].errors)) {
            result = false;
          } else {
            if (this.isRequired(sheet)) {
              result = !isEmpty(this.resultData[sheet2].data);
            }
          }
        }
      }
    } else {
      result = false;
    }

    this.isProcess = result;

    if (this.isProcess) {
      message = 'The file is valid, you can proceed to load';
    } else {
      message = 'The file contains errors, please check it and try again';
    }

    this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    }).present();
  }

  public emitResult() {
    this.utilities.consoleDecorator('Emit', this.resultData);
    // Se envia el archivo
    this.emitFile.emit(this.loadFiles.item(0));
    // Se envian los datos en JSON
    this.emitRecords.emit(this.resultData);
  }
}


// WEBPACK FOOTER //
// ./src/components/import-xlsx/import-xlsx.component.ts